var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('page-poster-with-image',{attrs:{"headline":_vm.headline,"paragraph":_vm.paragraph,"src":"/img/posters/promisesPoster.png","alt":_vm.$t('woman.promises')}}),_c('promises-items'),_c('page-info-footer-row')],1)}
var staticRenderFns = []

export { render, staticRenderFns }